import { c } from '../../contract';
import type {
  RevenueJarAppQuery,
  RevenueJarCustomerInfo,
  RevenueJarErrorResponse,
  RevenueJarOfferingsResponse,
  RevenueJarPromotionalOfferRequest,
  RevenueJarPromotionalOfferResponse,
  RevenueJarReceiptRequest,
  RevenueJarReceiptResponse,
} from '../../types/RevenueJar';

const errorResponses = {
  400: c.type<RevenueJarErrorResponse>(),
  403: c.type<RevenueJarErrorResponse>(),
  404: c.type<RevenueJarErrorResponse>(),
  409: c.type<RevenueJarErrorResponse>(),
  422: c.type<RevenueJarErrorResponse>(),
  500: c.type<RevenueJarErrorResponse>(),
  502: c.type<RevenueJarErrorResponse>(),
  503: c.type<RevenueJarErrorResponse>(),
};

export const revenueJarRouter = c.router(
  {
    getOfferings: {
      summary: "Get the offerings of one app from RevenueJar's in-app API",
      method: 'GET',
      path: '/offerings',
      query: c.type<RevenueJarAppQuery>(),
      responses: {
        200: c.type<RevenueJarOfferingsResponse>(),
        ...errorResponses,
      },
    },
    getEntitlements: {
      summary: "Get the user's customer info in the app's project from RevenueJar's in-app API",
      method: 'GET',
      path: '/entitlements',
      query: c.type<RevenueJarAppQuery>(),
      responses: {
        200: c.type<RevenueJarCustomerInfo>(),
        ...errorResponses,
      },
    },
    postReceipt: {
      summary: "Process a purchase or restore receipt with RevenueJar's in-app API",
      method: 'POST',
      path: '/receipts',
      body: c.type<RevenueJarReceiptRequest>(),
      responses: {
        200: c.type<RevenueJarReceiptResponse>(),
        ...errorResponses,
      },
    },
    postPromotionalOffer: {
      summary: "Get the signature of an iOS promotional offer from RevenueJar's in-app API",
      method: 'POST',
      path: '/promotional-offers',
      body: c.type<RevenueJarPromotionalOfferRequest>(),
      responses: {
        200: c.type<RevenueJarPromotionalOfferResponse>(),
        ...errorResponses,
      },
    },
  },
  { pathPrefix: '/revenue-jar' },
);
